import { cn } from '@/shared/cn';

export type ReconStatus =
  | 'MATCH' | 'QTY_MISMATCH' | 'ONLY_IN_PORTFOLIO' | 'ONLY_IN_DP' | 'ISIN_UNRESOLVABLE'
  // transactions_v1 statuses
  | 'PARTIAL_MATCH' | 'TXN_ALL_UNMATCHED' | 'TXN_OUTSIDE_WINDOW'
  | 'SLB_OUTSTANDING';

const STYLES: Record<ReconStatus, { label: string; cls: string }> = {
  MATCH:               { label: 'Match',             cls: 'bg-emerald-100 text-emerald-800 border border-emerald-200' },
  QTY_MISMATCH:        { label: 'Qty mismatch',      cls: 'bg-amber-100  text-amber-800  border border-amber-200' },
  ONLY_IN_PORTFOLIO:   { label: 'Only in portfolio', cls: 'bg-axis-cloud-100 text-axis-ink border border-axis-cloud-200' },
  ONLY_IN_DP:          { label: 'Only in DP',        cls: 'bg-axis-maroon/10 text-axis-maroon border border-axis-maroon/30' },
  ISIN_UNRESOLVABLE:   { label: 'ISIN unresolvable', cls: 'bg-rose-100 text-rose-800 border border-rose-200' },
  // Txn-mode statuses
  PARTIAL_MATCH:       { label: 'Partial match',     cls: 'bg-amber-100  text-amber-800  border border-amber-200' },
  TXN_ALL_UNMATCHED:   { label: 'All unmatched',     cls: 'bg-rose-100 text-rose-800 border border-rose-200' },
  TXN_OUTSIDE_WINDOW:  { label: 'Outside window',    cls: 'bg-axis-cloud-100 text-axis-ash border border-axis-cloud-200' },
  // Real economic state — shares lent via SLB and not yet returned.
  // Visually distinct (sky blue) from amber QTY_MISMATCH because it's
  // informational, not a reconciliation error to investigate.
  SLB_OUTSTANDING:     { label: 'SLB outstanding',   cls: 'bg-sky-100 text-sky-800 border border-sky-200' },
};

export function StatusPill({ status, hasUnmatched }: { status: ReconStatus; hasUnmatched?: boolean }) {
  const s = STYLES[status];
  if (!s) return <span className="pill bg-axis-cloud-100">{status}</span>;
  // When status=MATCH but there are red (unmatched) bands visible, override to red.
  const cls = (status === 'MATCH' && hasUnmatched)
    ? 'bg-rose-100 text-rose-800 border border-rose-200'
    : s.cls;
  return <span className={cn('pill', cls)}>{s.label}</span>;
}
